export enum AuthReduxActions {
  AUTH_SET_LOGIN_STATUS = 'AUTH_SET_LOGIN_STATUS',
  LOGOUT = 'LOGOUT',
}

const setLoginStatus = (payload: any): any => ({
  type: AuthReduxActions.AUTH_SET_LOGIN_STATUS,
  payload,
});

const doLogout = (payload: any): any => ({
  type: AuthReduxActions.LOGOUT,
  payload,
});

export const AuthActions = {
  setLoginStatus,
  doLogout,
};
